import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { OLD_PRICE, PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/wf';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-230" data-mp="1mmha6mw3nom6">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-231" data-mp="1hpqs5u0qiiy4">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-232" data-mp="ty1xw84crkej">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-233" data-mp="u0oc2qlr0y5q">
            Poznaj swój kompletny pakiet <em className="text-red-300" data-id="element-234" data-mp="13wrbhop7uioz">WF GOTOWY™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-235" data-mp="13uoe2jlqhna8">
            Lekcje WF na cały rok gotowe w zaledwie 5 minut.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-236" data-mp="2fb504vrsn262" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-237" data-mp="2af7hgit25jq4">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-238" data-mp="uisdtehd8suq">Kompletny pakiet zawiera</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-239" data-mp="zhvd0iao04us">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-240" data-mp="13k9r6p3e2gfq">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-241" data-mp="6tpr3s7vk9td">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-242" data-mp="bsaqxqj7srha" />
                </span>
                <span data-id="element-243" data-mp="ftctag8fhjnh">
                  <span className="block font-medium leading-snug" data-id="element-244" data-mp="fsuq0zncm562">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-245" data-mp="klxkrb3v3knu">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-246" data-mp="3o9z9xd77qmdp">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-247" data-mp="ve61qa8vnpta">
              Cena wprowadzająca{' '}
              <span className="sr-only" data-id="element-248" data-mp="qge02oifkpbw">– cena regularna: </span>
              <s className="ml-1 font-serif text-xl text-slate-900/50" data-id="element-249" data-mp="154ijjupb54vq">{OLD_PRICE}</s>
            </p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-250" data-mp="107id3iojq043">
              <span className="sr-only" data-id="element-251" data-mp="chxwh6fv7exz">Cena teraz: </span>
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-252" data-mp="7jcryutky93q">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-253" data-mp="livzblekhgez" />
            Jednorazowa płatność. Bez subskrypcji.
          </p>

          <CtaButton label="Zamów cały pakiet teraz" className="mt-8 w-full" data-id="element-254" data-mp="1wwq3p540uzev" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-255" data-mp="1wysx7z4dvaoc">
            {offerIncludes.map(item => <li key={item} data-id="element-256" data-mp="20e4bdsqoqipm">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}